var React = require('react');

function BigX (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.4 10l8.3-8.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L10 8.6 1.7.3C1.3-.1.7-.1.3.3s-.4 1 0 1.4L8.6 10 .3 18.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3s.5-.1.7-.3l8.3-8.3 8.3 8.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L11.4 10z"}));
}

BigX.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = BigX;

BigX.default = BigX;
